<shell-leal-toast
  id="lealSuccesToast"
  type="success"
  icon="ti-circle-check"
  [time]="succesToastOptions.toastTime"
  content-title="¡ Actualización de contraseña exitoso !"
  content="La contraseña se ha restablecido satisfactoriamente."
  [isShowing]="succesToastOptions.isShowing"
  (closingToast)="closingSuccesToast()"
  />


<shell-leal-toast
  id="lealErrorToast"
  type="error"
  icon="ti-alert-triangle"
  [time]="errorToastOptions.toastTime"
  content-title="¡Oh no!, tenemos un error de validación."
  content="Por favor verifica los datos ingresados e inténtalo nuevamente."
  [isShowing]="errorToastOptions.isShowing"
  (closingToast)="closingErrorToast()"
  />


<shell-leal-grid [style]="{display: 'grid', height: '100vh', padding: '0'}">
  <shell-leal-row class="form-container" align-items="center" justify="center">
    <shell-leal-col col="12" col-xs="8" col-md="6" col-lg="4">
      <shell-leal-box- mb="64" [customStyles]="{'text-align': 'center'}">
        <img src="/assets/images/logoLeal.svg" alt="" width="128px" style="margin: auto;">
      </shell-leal-box->
      <div>
        <div>
          <shell-leal-text size="large-3xl" weight="f-700" color="gray-10" font="Montserrat">
            Recuperar contraseña
          </shell-leal-text>
          <shell-leal-box mt="40" pr="0"  pl="0" unit="px">
            <shell-leal-text size="x-small" weight="f-500" color="gray-8">
              Ingresa tu nueva contraseña
            </shell-leal-text>
            <shell-leal-box mt="8" mr="0" mb="8" ml="0" unit="px">
              <shell-leal-input
                id="newPassword"
                category="password"
                placeholder="Contraseña"
                background="white"
                placeholder-color="gray"
                size="base"
                icon-position="left"
                required="true"
                icon="key"
                (changeInput)="onChangeNewPassword($event)"
                (keyup.enter)="recoverPassword()"
                [customId]="'leal-input-new-pass'"
                />
            </shell-leal-box>
          </shell-leal-box>
          <shell-leal-box mt="32" pr="0"  pl="0" unit="px">
            <shell-leal-text size="x-small" weight="f-500" color="gray-8">
              Confirma la contraseña
            </shell-leal-text>
            <shell-leal-box mt="8" mr="0" mb="8" ml="0" unit="px">
              <shell-leal-input
                id="passwordConfirm"
                category="password"
                placeholder="Contraseña"
                background="white"
                placeholder-color="gray"
                size="base"
                icon-position="left"
                required="true"
                icon="key"
                (changeInput)="onChangePasswordConfirm($event)"
                (keyup.enter)="recoverPassword()"
                />
            </shell-leal-box>
          </shell-leal-box>
          <shell-leal-box>
            <shell-leal-text color="red-6" size="x-small">
              {{ getErrorMessage() }}
          </shell-leal-text>
          </shell-leal-box>
          <shell-leal-box mt="40" pr="0"  pl="0" unit="px">
            <shell-leal-button
              [customStyles]="{
                width: '100%',
                display: 'flex',
                'align-items': 'center',
                'justify-content': 'center',
              }"
              text="Recuperar contraseña"
              [disabled]="disabledButton"
              (clickButton)="recoverPassword()"
              [customId]="'leal-input-new-pass-button'"
              />
          </shell-leal-box>
        </div>
      </div>
    </shell-leal-col>
  </shell-leal-row>
</shell-leal-grid>
